import { PerfiosConstants } from '../Constants';
import { PerfiosService } from '../Services';

export const PerfiosActions = {
    postNetbanking,
    postUploadStatement
}

function postNetbanking(payload) {
    return dispatch => {
        dispatch(request());
        PerfiosService.postNetbanking(payload)
            .then(payload => dispatch(success(payload)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: PerfiosConstants.POST_NETBANKING_REQUEST } }
    function success(payload) { return { type: PerfiosConstants.POST_NETBANKING_SUCCESS, payload } }
    function failure(error) { return { type: PerfiosConstants.POST_NETBANKING_FAILURE, error } }
}

function postUploadStatement(payload) {
    return dispatch => {
        dispatch(request());
        PerfiosService.postUploadStatement(payload)
            .then(payload => dispatch(success(payload)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: PerfiosConstants.POST_UPLOAD_STATEMENT_REQUEST } }
    function success(payload) { return { type: PerfiosConstants.POST_UPLOAD_STATEMENT_SUCCESS, payload } }
    function failure(error) { return { type: PerfiosConstants.POST_UPLOAD_STATEMENT_FAILURE, error } }
}